import { Component, ElementRef, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'no-result-found',
  templateUrl: './no-result-found.component.html',
  styleUrls: ['./no-result-found.component.scss'],
  standalone: true,
  imports: [TranslatePipe]
})
export class NoResultFoundComponent implements OnInit {

  constructor() {

   
  }

  ngOnInit(): void {
   
  }


}
